import styled from 'styled-components';

interface PropTypes {
  transitionDuration: number;
  easing: string;
  onTransitionEnd: (e: Event) => void;
  style?: object;
}

export const ContentWrapper = styled.div<PropTypes>`
  overflow: hidden;
  @media (prefers-reduced-motion: no-preference) {
    transition: ${(props) => `height ${props.transitionDuration}s ${props.easing}`};
  }
  @media (prefers-reduced-motion) {
    transition: none;
  }
`;
